if(typeof translations === 'undefined') { var e = new Error("Cannot find module 'translations'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = translations;